import styled from '@emotion/styled'

export const Content = styled.div<{ setIndex: boolean }>`
  position: relative;
  outline: none;
  z-index: ${({ setIndex }) => (setIndex ? -1 : 'unset')};
  & > div {
    padding-top: 0;
  }
`
